<template>
  <div id="huro-app" class="app-wrapper">
    <div class="app-overlay"></div>

    <Header v-if="$route.name != 'Login'" />

    <div id="app-onboarding" :page="$route.name" :style="
        $route.name == 'ExerciseDetail' ||
        $route.name == 'CourseDetail' ||
        $route.name == 'ForKids' ||
        $route.name == 'Siir' ||
        $route.name == 'Tekerleme' ||
        $route.params.type == 'kare-okuma' ||
        $route.params.type == 'takistoskop' ||
        $route.params.type == 'kelime-egzersizi' ||
        $route.params.type == 'ileri-seviye-kare-okuma' ||
        $route.params.type == 'siir' ||
        $route.params.type == 'ileri-seviye-siir' ||
        $route.params.type == 'tekerleme' ||
        $route.params.type == 'ileri-seviye-tekerleme' ||
        $route.params.type == 'heceleme' ||
        $route.params.type == 'metin-okuma' ||
        $route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
        $route.params.type == 'odak-okuma' ||
        $route.name == 'RepeatCourse'
          ? 'padding: 0px !important;'
          : $route.name == 'Login'
          ? 'padding: 0px !important; margin: 0px !important; '
          : 'padding-left: 250px !important; background-image: url(/static/Egzersiz%20Ekranı.png);        min-height: 100vh;        background-size: auto 100%;        background-repeat: no-repeat;        background-position: center;        background-position-x: 250px;'
      " class="view-wrapper is-webapp" :class="$route.name == 'ExerciseDetail' ? 'exercise-detail' : ''"
      data-page-title="Blank Template" data-naver-offset="214" data-menu-item="#layouts-navbar-menu"
      data-mobile-item="#home-sidebar-menu-mobile">
      <LeftMenu style="transition: 0.3s" :style="
          $route.name == 'ExerciseDetail' ||
          $route.name == 'CourseDetail' ||
          $route.name == 'ForKids' ||
          $route.name == 'Siir' ||
          $route.name == 'Tekerleme' ||
          $route.params.type == 'kare-okuma' ||
          $route.params.type == 'takistoskop' ||
          $route.params.type == 'kelime-egzersizi' ||
          $route.params.type == 'ileri-seviye-kare-okuma' ||
          $route.params.type == 'siir' ||
          $route.params.type == 'ileri-seviye-siir' ||
          $route.params.type == 'tekerleme' ||
          $route.params.type == 'ileri-seviye-tekerleme' ||
          $route.params.type == 'heceleme' ||
          $route.params.type == 'metin-okuma' ||
          $route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
          $route.params.type == 'odak-okuma' ||
          $route.name == 'RepeatCourse'
            ? 'left: -250px;'
            : '0px;'
        " v-if="$route.name != 'Login'" />
      <div class="page-content-wrapper" :style="
          $route.name == 'Login' ||
          $route.name == 'CourseDetail' ||
          $route.name == 'ForKids' ||
          $route.name == 'Siir' ||
          $route.name == 'Tekerleme' ||
          $route.name == 'ExercisesChild' ||
          $route.params.type == 'kare-okuma' ||
          $route.params.type == 'takistoskop' ||
          $route.params.type == 'kelime-egzersizi' ||
          $route.params.type == 'ileri-seviye-kare-okuma' ||
          $route.params.type == 'siir' ||
          $route.params.type == 'ileri-seviye-siir' ||
          $route.params.type == 'tekerleme' ||
          $route.params.type == 'ileri-seviye-tekerleme' ||
          $route.params.type == 'heceleme' ||
          $route.params.type == 'metin-okuma' ||
          $route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
          $route.name == 'RepeatCourse' ||
          $route.params.type == 'odak-okuma' ||
          $route.name == 'Home'
            ? 'max-width: 100%;'
            : ''
        ">
        <div class="page-content is-relative" :style="
            $route.name == 'Login' ||
            $route.name == 'CourseDetail' ||
            $route.name == 'RepeatCourse' ||
            $route.name == 'ForKids' ||
            $route.name == 'Siir' ||
            $route.name == 'Tekerleme' ||
            $route.name == 'ExercisesChild' ||
            $route.params.type == 'kare-okuma' ||
            $route.params.type == 'takistoskop' ||
            $route.params.type == 'kelime-egzersizi' ||
            $route.params.type == 'ileri-seviye-kare-okuma' ||
            $route.params.type == 'siir' ||
            $route.params.type == 'ileri-seviye-siir' ||
            $route.params.type == 'tekerleme' ||
            $route.params.type == 'ileri-seviye-tekerleme' ||
            $route.params.type == 'heceleme' ||
            $route.params.type == 'metin-okuma' ||
            $route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
            $route.params.type == 'odak-okuma' ||
            $route.name == 'Home'
              ? 'padding: 0px !important;'
              : ''
          ">
          <div class="page-content-inner" :style="
              $route.name == 'Login' ||
              $route.name == 'CourseDetail' ||
              $route.name == 'RepeatCourse' ||
              $route.name == 'ForKids' ||
              $route.name == 'Siir' ||
              $route.name == 'Tekerleme' ||
              $route.name == 'ExercisesChild' ||
              $route.params.type == 'kare-okuma' ||
              $route.params.type == 'takistoskop' ||
              $route.params.type == 'kelime-egzersizi' ||
              $route.params.type == 'ileri-seviye-kare-okuma' ||
              $route.params.type == 'siir' ||
              $route.params.type == 'ileri-seviye-siir' ||
              $route.params.type == 'tekerleme' ||
              $route.params.type == 'ileri-seviye-tekerleme' ||
              $route.params.type == 'heceleme' ||
              $route.params.type == 'metin-okuma' ||
              $route.params.type == 'duzelt-bakalim-cocuklar-icin' ||
              $route.params.type == 'odak-okuma' ||
              $route.name == 'Home'
                ? 'margin: 0px;'
                : ''
            ">
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-if="$store.state.user != null" id="emotion_modal" :visible.sync="welcomeVideoModal"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" width="700px">
      <video v-if="ended === false" autoplay style="background-color: transparent; width: 100%; height: 100%"
        :src="videoUrl" id="player"></video>
    </el-dialog>
    <el-dialog v-if="$store.state.user != null" id="emotion_modal" :visible.sync="visible" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" width="700px">
      <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        ">
        <h3>{{ $t("app.hello") }} {{ $store.state.user.firstname }}</h3>

        <p style="
            font-size: 19px;
            text-align: center;
            margin-bottom: 20px;
            word-break: break-word;
          ">
          {{ $t("app.hello_description") }}
        </p>
        <h4>{{ $t("app.howareu") }}</h4>
        <el-rate :show-text="true" v-model="emotion" :icon-classes="iconClasses" :texts="[
            $t('app.cokkotu'),
            $t('app.kotu'),
            $t('app.idareeder'),
            $t('app.good'),
            $t('app.super'),
          ]" void-icon-class="fas fa-meh-blank" :colors="['#99A9BF', '#F7BA2A', '#FF9900']">
        </el-rate>
        <h4 class="mt-5 mb-2">{{ $t("app.sleep") }}</h4>
        <el-radio-group v-model="sleep" size="medium">
          <el-radio-button :label="i.value" v-for="i in hours">{{
            i.title
            }}</el-radio-button>
        </el-radio-group>

        <h4 class="mt-5 mb-2">Kaç Sayfa Kitap Okudunuz?</h4>
        <el-input-number v-model="page"></el-input-number>

        <h4 class="mt-5 mb-2">Kaç Dakika Kitap Okudunuz?</h4>
        <el-input-number v-model="read_time"></el-input-number>
        <el-button round type="primary" style="
            width: 40%;
            padding: 10px 15px;
            font-size: 18px;
            margin-top: 40px;
          " v-if="sleep != null && emotion != 0" @click="save">
          {{ $t("app.save") }}
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Header from "@/components/Header";
import LeftMenu from "@/components/LeftMenu";
import axios from "axios";
export default {
  name: "App",
  components: {
    Header,
    LeftMenu,
  },
  data() {
    return {
      ended: false,
      player: null,
      videoUrl: null,
      welcomeVideoModal: false,
      showUpdateMessage: false,
      visible: false,
      iconClasses: {
        1: "fas fa-frown",
        2: "fas fa-meh",
        3: "fas fa-meh-rolling-eyes",
        4: "fas fa-smile-beam",
        5: "fas fa-grin-stars",
      },
      emotion: null,
      sleep: null,
      page: null,
      read_time: null,
      appVer: null,
      hours: [
        {
          title: this.$t("app.five"),
          value: 5,
        },
        {
          title: "6",
          value: 6,
        },
        {
          title: "7",
          value: 7,
        },
        {
          title: "8",
          value: 8,
        },
        {
          title: this.$t("app.nine"),
          value: 9,
        },
      ],
    };
  },
  mounted() {
    axios.get("account/get").then((res2) => {
      if (
        res2.data.data.user.foreign_user_id != null &&
        localStorage.getItem("merhaba_video") === null
      ) {
        localStorage.setItem("merhaba_video", "true");
        axios
          .post("course/video", {
            bucket_name: "hizli_okuma",
            video: "KURS VİDEOLARI/Merhaba.mp4",
          })
          .then((res) => {
            this.videoUrl = res.data.data;
            this.welcomeVideoModal = true;
            setTimeout(() => {
              this.player = new Plyr("#player");
              this.player.on("ended", () => {
                this.ended = true;
                this.welcomeVideoModal = false;
                this.player.fullscreen.exit();
              });
            }, 1000);
          });
      }
    });

    if (this.$store.state.darkmode === true) {
      $("html").addClass("is-dark");
      $("body").addClass("is-dark");
    } else {
      $("html").removeClass("is-dark");
      $("body").removeClass("is-dark");
    }
    axios.get("module/list").then((res) => {
      this.$store.state.modules = res.data.data;
    });
    axios.get("module/categories").then((res) => {
      this.$store.state.categories = res.data.data;
    });
    this.$root.$on("visible", (data) => {
      this.visible = true;
    });

    axios.get("app/version").then((res) => {
      if (
        res.data.data.version != window.appVersion &&
        localStorage.getItem("v-" + res.data.data.version) === null
      ) {
        this.showUpdateMessage = true;
        this.appVer = res.data.data.version;
      }
    });
  },
  methods: {
    refresh() {
      this.close();
      window.location.reload();
    },
    close() {
      localStorage.setItem("v-" + this.appVer, "closed");
    },
    save() {
      axios
        .post("emotion/save", { emotion: this.emotion, sleep: this.sleep, read_time: this.read_time, page: this.page })
        .then((res) => {
          this.visible = false;
        });
    },
  },
};
</script>

<style>
@import url(https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap&subset=latin-ext);
@import url(https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@600&display=swap);
</style>

<style lang="less">
@import "./assets/css/custom.less";

.num {
  font-family: "Josefin Sans", sans-serif !important;
  font-weight: 600 !important;
}

#emotion_modal {
  .el-dialog__header {
    display: none;
  }

  h3,
  h4 {
    font-size: 27px;
  }

  h4 {
    font-size: 22px;
  }

  .el-rate {
    line-height: 1;
    width: 100%;
    align-items: flex-start;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
    height: 80px;

    .el-rate__icon {
      font-size: 40px;
    }

    .el-rate__text {
      font-size: 22px;
      text-align: center;
      margin-top: 10px;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue